import config from '@/config'

export default {
  user_status: {
    NEW: "Pengguna baru, tetapi belum diverifikasi",
    ACTIVE: "Pengguna aktif",
    RESET: "Kata sandi pengguna telah direset",
    ATTEMPT_BLOCK: "Pengguna diblokir karena 3 kali percobaan login gagal",
    COMPANY_BLOCK: "Pengguna diblokir oleh perusahaan",
    SUSPEND: "Pengguna ditangguhkan"
  },

  login: "Masuk ke akun Anda",
  relogin: "Silakan masuk kembali ke akun Anda.",
  expired: "Sesi telah berakhir!",
  denied: "Izin Ditolak!",
  success: "BERHASIL",
  search_by_id: "Cari berdasarkan ID",
  search_by_full_id: "Cari berdasarkan ID lengkap",
  successful_change_password: "Anda telah berhasil mengubah kata sandi.",
  select_option: "Pilih opsi Anda",
  no_data_available: "Tidak Ada Data Tersedia",
  no_rating_available: "Tidak Ada Penilaian Tersedia",
  successful_update_security: "Kamu telah berhasil memperbarui keamanan.",
  successful_disable_security: "Kamu telah berhasil menonaktifkan keamanan.",
  update_security_confirm: "Apakah kamu yakin ingin memperbarui keamanan?",
  disable_security_confirm: "Apakah kamu yakin ingin menonaktifkan keamanan?",
  change_operator_status_confirm: "Apakah kamu yakin ingin mengubah status operator \"{name}\"?",
  change_member_status_confirm: "Apakah kamu yakin ingin mengubah status anggota \"{name}\"?",
  change_bank_account_status_confirm: "Apakah kamu yakin ingin mengubah status akun \"{name}\"?",
  change_promotion_seq_confirm: "Apakah kamu yakin ingin mengubah urutan \"{id}\"?",
  change_promo_status_confirm: "Apakah kamu yakin ingin mengubah status promosi \"{name}\"?",
  change_promo_signup_status_confirm: "Apakah kamu yakin ingin mengubah status pendaftaran promosi \"{name}\"?",
  successful_update_account_setup: "Kamu telah berhasil memperbarui pengaturan akun.",
  unblock_member_confirm: "Apakah kamu yakin ingin membuka blokir anggota \"{name}\"?",
  unblock_operator_confirm: "Apakah kamu yakin ingin membuka blokir operator \"{name}\"?",
  block_sub_account_confirm: "Apakah kamu yakin ingin memblokir sub akun \"{name}\"?",
  unblock_sub_account_confirm: "Apakah kamu yakin ingin membuka blokir sub akun \"{name}\"?",
  successful_create_secondary_account: "Kamu telah berhasil membuat akun sekunder.",
  successful_update_account_password: "Anda telah berhasil memperbarui kata sandi akun.",
  update_account_password_cancel: "Apakah Anda yakin ingin membatalkan pembaruan kata sandi akun?",
  change_affiliate_status_confirm: "Apakah Anda yakin ingin mengubah status afiliasi \"{name}\"?",
  unblock_affiliate_confirm: "Apakah Anda yakin ingin membuka blokir afiliasi \"{name}\"?",
  change_coupon_status_confirm: "Apakah Anda yakin ingin mengubah status kupon \"{name}\"?",
  submit_acknowledgement_confirm: "Apakah Anda yakin ingin mengirimkan pengakuan?",
  change_bank_group_default_confirm: "Apakah Anda yakin ingin menetapkan \"{name}\" sebagai grup bank default?",
  change_withdrawal_limit_default_confirm: "Apakah Anda yakin ingin menetapkan \"{name}\" sebagai batas penarikan default?",
  change_promotion_group_default_confirm: "Apakah Anda yakin ingin menetapkan \"{name}\" sebagai grup promosi default?",
  change_referral_status_confirm: "Apakah Anda yakin ingin mengubah status rujukan \"{name}\"?",
  change_withdrawal_limit_confirm: "Apakah Anda yakin ingin mengubah batas penarikan \"{name}\"?",
  change_promotion_group_confirm: "Apakah Anda yakin ingin mengubah grup promosi \"{name}\"?",
  change_bank_group_confirm: "Apakah Anda yakin ingin mengubah grup bank \"{name}\"?",
  change_member_bet_limit_confirm: "Apakah Anda yakin ingin mengubah batas taruhan \"{name}\" \"{provider}\"?",
  assign_free_credit_confirm: "Apakah Anda yakin ingin memberikan kredit gratis kepada \"{name}\"?",
  update_survey_status_confirm: "Apakah Anda yakin ingin memperbarui status survei?",
  move_banner_up_confirm: "Apakah Anda yakin ingin memindahkan banner \"{name}\" ke atas?",
  move_banner_down_confirm: "Apakah Anda yakin ingin memindahkan banner \"{name}\" ke bawah?",
  delete_banner_confirm: "Apakah Anda yakin ingin menghapus banner \"{name}\"?",
  change_banner_status_confirm: "Apakah Anda yakin ingin mengubah status banner \"{name}\"?",
  delete_page_confirm: "Apakah Anda yakin ingin menghapus halaman \"{name}\"?",
  change_page_status_confirm: "Apakah Anda yakin ingin mengubah status halaman \"{name}\"?",
  clear_maintenance_time_confirm: "Apakah Anda yakin ingin menghapus waktu pemeliharaan \"{name}\"?",
  successful_clear_outstanding: "Anda telah berhasil menyelesaikan jumlah outstanding sebesar {amt}.",
  clear_outstanding_confirm: "Apakah Anda yakin ingin menyelesaikan tunggakan \"{name}\"?",
  trace_outstanding_confirm: "Apakah Anda yakin ingin melacak tunggakan \"{name}\"?",
  change_setting_confirm: "Apakah Anda yakin ingin mengubah pengaturan \"{name}\"?",
  add_bonus_list_member_confirm: "Apakah Anda yakin ingin menambahkan anggota yang dipilih ke daftar bonus?",
  delete_bonus_list_member_confirm: "Apakah Anda yakin ingin menghapus anggota yang dipilih dari daftar bonus?",
  delete_ip_address_confirm: "Apakah Anda yakin ingin menghapus ip \"{ip}\" di bawah \"{name}\"?",
  add_ip_address_confirm: "Apakah Anda yakin ingin menambahkan ip \"{ip}\" di bawah \"{name}\"?",
  change_payment_mode_status_confirm: "Apakah Anda yakin ingin mengubah status mode pembayaran \"{name}\"?",
  change_provider_group_status_confirm: "Apakah Anda yakin ingin mengubah status \"{group}\" di bawah \"{mode}\"?",
  bulk_issue_bonus_member_confirm: "Apakah Anda yakin ingin memberikan bonus kepada anggota dalam daftar bonus?",
  change_provider_group_recommend_confirm: "Apakah Anda yakin ingin mengubah rekomendasi \"{group}\" di bawah \"{mode}\"?",
  change_provider_group_seq_confirm: "Apakah Anda yakin ingin mengubah urutan \"{group}\" di bawah \"{mode}\"?",
  no_member_found: "Tidak Ada Anggota Ditemukan",
  redeposit_ticket_confirm: "Apakah Anda yakin ingin mendeposit tiket lagi?",
  change_provider_group_limit_confirm: "Apakah Anda yakin ingin mengubah batas \"{group}\" di bawah \"{mode}\"?",
  audit_ticket_confirm: "Apakah Anda yakin ingin mengaudit tiket ini?",
  review_ticket_confirm: "Apakah Anda yakin ingin meninjau tiket ini?",
  change_promotion_group_seq_confirm: "Apakah Anda yakin ingin mengubah urutan \"{promotion}\" di bawah \"{group}\"?",
  unlock_custom_vip_confirm: "Apakah Anda yakin ingin membuka kunci vip kustom \"{name}\"?",
  move_affiliate_confirm: "Apakah Anda yakin ingin memindahkan seluruh cabang \"{name}\" langsung di bawah \"{operator}\"?",
  cancel_unfinish_round_confirm: "Apakah Anda yakin ingin membatalkan putaran yang belum selesai \"{round}\"?",
  change_payment_mode_seq_confirm: "Apakah Anda yakin ingin mengubah urutan \"{mode}\"?Apakah Anda yakin ingin membatalkan putaran yang belum selesai \"{round}\"?",
  remove_bank_default_provider_confirm: "Apakah Anda yakin ingin menghapus penyedia default \"{bank}\"?",
  change_label_status_confirm: "Apakah Anda yakin ingin mengubah status label \"{name}\"?",
  clear_iframe_url_confirm: "Apakah Anda yakin ingin menghapus URL iframe?Apakah Anda yakin ingin mengubah status label \"{name}\"?",
  delete_turnover_tier_confirm: "Apakah Anda yakin ingin menghapus tingkat omset \"{name}\"?",
  vip_provider_rebate_batch_confirm: "Apakah Anda yakin untuk melanjutkan pembaruan batch rebate penyedia VIP?",
  copy_rebate_rate_all_confirm: "Apakah Anda yakin ingin menyalin \"{name}\" dari \"{provider}\" ke semua penyedia?，",
  edit_vip_confirm: "Apakah Anda ingin memperbarui tarif rebate dari \"{name}\"?",
  add_promotion_custom_member_confirm: "Apakah Anda ingin menambahkan daftar anggota kustom promosi?",
  delete_promotion_custom_member_confirm: "Apakah Anda ingin menghapus daftar anggota kustom promosi \"{name}\"?",
  change_rescue_fund_status_confirm: "Apakah Anda yakin ingin mengubah status dana penyelamatan \"{name}\"?",
  add_rescue_fund_custom_member_confirm: "Apakah Anda ingin menambahkan daftar anggota kustom dana penyelamatan?",
  delete_rescue_fund_custom_member_confirm: "Apakah Anda ingin menghapus daftar anggota kustom dana penyelamatan \"{name}\"?",
  change_ads_status_confirm: "Apakah Anda yakin ingin mengubah status iklan \"{name}\"?",
  adjust_amount_bank_tooltip: "Dukung tanda minus (-) untuk mengurangi saldo dari saldo rekening bank",
  adjust_amount_operator_tooltip: "Dukung tanda minus (-) untuk mengurangi saldo dari dompet operator",
  adjust_amount_member_tooltip: "Dukung tanda minus (-) untuk mengurangi saldo dari saldo anggota",
  purchase_domain_tooltips: "Selamat!! Semoga impianmu terwujud!",
  change_provider_game_seq_confirm: "Apakah Anda yakin ingin mengubah urutan \"{mode}\"?",
  purchase_domain_confirm: "Apakah Anda yakin ingin membeli domain \"{name}\"?",
  search_by_domain_name: "Cari Berdasarkan Nama Domain",
  search_by_domain_status: "Cari Berdasarkan Status Domain",
  search_by_account_id: "Cari Berdasarkan ID Akun",
  search_by_operator_id: "Cari Berdasarkan ID Operator",
  search_by_full_name: "Cari Berdasarkan Nama Lengkap",
  search_by_contact_phone: "Cari Berdasarkan Nomor Telepon Kontak",
  search_by_signup_ip: "Cari Berdasarkan IP Pendaftaran",
  search_by_referral_code: "Cari Berdasarkan Kode Referensi",
  search_by_bank_acc_no: "Cari Berdasarkan Nomor Rekening Bank",
  search_by_affiliate_code: "Cari Berdasarkan Kode Afiliasi",
  info1: "1. Subdomain tidak diperbolehkan",
  info2: "2. Tidak memerlukan 'https://' atau 'http://'",
  info3: "3. Contoh: abc.com",
  move_announcement_banner: "Urutkan ulang banner",
  atLeastOneChecked: "Setidaknya satu ambang batas perlu diperiksa",
  adjustWalletTooltips: "Dukungan tanda minus (-) untuk mengurangi saldo dari dompet afiliasi",
  emailOTPTooltips: "Email OTP akan kedaluwarsa dalam 3 menit setelah permintaan",
  domain_status_update_confirm: "Apakah Anda ingin memperbarui status \"{name}\"?",
  delete_access_control_confirm: "Apakah Anda yakin ingin menghapus \"{name}\"?",
  delete_access_control_success: "Anda telah berhasil menghapus \"{name}\".",
  add_access_control_confirm: "Apakah Anda yakin ingin menambahkan kontrol akses?",
  add_access_control_success: "Anda telah berhasil menambahkan kontrol akses.",
  delete_access_auto_confirm: "Apakah Anda yakin ingin menghapus \"{name}\"?",
  delete_access_auto_success: "Anda telah berhasil menghapus \"{name}\".",
  add_access_auto_confirm: "Apakah Anda yakin ingin menambahkan ke dalam penugasan otomatis?",
  add_access_auto_success: "Anda telah berhasil menambahkan ke dalam penugasan otomatis.",
  move_banner_confirm: "Apakah Anda yakin ingin mengubah \"{name}\" ke posisi \"{position}\"?",
  delete_game_exclude_confirm: "Apakah Anda yakin ingin menghapus \"{name}\"?",
  banner_size_tooltips: "Silakan ikuti dimensi ukuran gambar yang diizinkan: \"{size}\".",
  purchase_domain_success: "Pembelian domain berhasil!",
  purchase_domain_failed: "Pembelian domain gagal!",
  apply_domain_success: "Pengajuan domain berhasil!",
  apply_domain_failed: "Pengajuan domain gagal!",
  tooltips_pnl: "Platform winlose x Platform PT % = Total Pendapatan",
  delete_package_confirm: "Apakah Anda yakin ingin menghapus paket \"{package}\"?",
  search_by_lang_code: "Telusuri berdasarkan Kode Bahasa",
  pleaseSelectAnImage: "Silakan Pilih Gambar",
  pleaseSelectAValidImageType: "Silakan Pilih Tipe Gambar yang Valid",
  imageTooLargeMaxSizeAllowedIsOneMb: "Gambar terlalu besar, ukuran maksimum yang diizinkan adalah 1MB",
  uploadYourLogoWithPngOrJpegFormat: "Unggah logo Anda dengan format png atau jpeg",
  allowedPngAndJpegOnlyMaxOneMb: "Hanya png dan jpeg yang diizinkan (Ukuran gambar maksimum 1MB)",
  delete_theme_content_confirm: "Apakah Anda yakin ingin menghapus konten tema \"{themecontent}\"?",
  delete_theme_confirm: "Apakah Anda yakin ingin menghapus tema \"{theme}\"?",
  delete_color_confirm: "Apakah Anda yakin ingin menghapus warna \"{color}\"?",
  delete_content_confirm: "Apakah Anda yakin ingin menghapus konten \"{content}\"?",
  reset_password_confirm: "Apakah Anda yakin ingin mengatur ulang kata sandi untuk \"{userid}\"?",
  block_account_confirm: "Apakah Anda yakin ingin memblokir \"{userid}\"?",
  suspend_account_confirm: "Apakah Anda yakin ingin menangguhkan \"{userid}\"?",
  active_account_confirm: "Apakah Anda yakin ingin mengaktifkan \"{userid}\"?",
  temporaryPasswordFor: "Kata sandi sementara untuk \"{name}\" adalah",
  needAiToGenerateLogo: "Perlu AI untuk membuat logo",
  delete_domain_confirm: "Apakah Anda yakin ingin menghapus domain \"{domain}\"?",
  previewImageForIllustrationOnly: "Gambar pratinjau yang ditampilkan hanya untuk tujuan ilustrasi.",
  actualResultMayVary: "Hasil aktual dapat bervariasi karena peningkatan situs web.",
  chooseYourPreferedResponsiveLayoutTheme: "Pilih tema tata letak responsif yang Anda inginkan",
  chooseYourPreferedColor: "Pilih Warna yang Anda Inginkan",
  please_update_provider_before_edit_game: "Tolong perbarui penyedia sebelum mengedit permainan",
  delete_theme_content_group_confirm: "Apakah Anda yakin ingin menghapus grup konten tema \"{themecontentgroup}\"?",
  phoneFormat: "mis. +63XXXXXXXXXX",
  change_theme_will_replace_menu: "Apakah Anda yakin ingin memperbarui tema? (Ganti tema akan menyebabkan Menu diganti)",
  change_provider_seq_confirm: "Apakah Anda yakin ingin mengubah urutan \"{provider}\"?",
  change_provider_status_confirm: "Apakah Anda yakin ingin mengubah status penyedia \"{provider}\"?",
  actionPerformWillReflectProd: "* Setiap tindakan yang dilakukan di sini akan langsung tercermin di Produksi",
  site_sync_confirm: "Apakah Anda yakin ingin menyinkronkan ke Produksi?",
  clear_profile_setting_maintenance_confirm: "Apakah Anda yakin ingin menghapus pemeliharaan?",
  change_social_platform_status_confirm: "Apakah Anda yakin ingin mengubah status platform sosial \"{name}\"?",
  search_by_site_name: "Cari Berdasarkan Nama Situs",
  change_social_account_status_confirm: "Apakah Anda yakin ingin mengubah status akun sosial \"{name}\"?",
  themeMenuMessage1: "* Atur ulang urutan menu dengan menyeret dan menjatuhkan item menu",
  themeMenuMessage2: "* Hapus centang kotak jika ingin menyembunyikan item menu",
  search_by_operator: "Cari Berdasarkan Operator",
  search_by_ticket: "Cari Berdasarkan Tiket",
  search_member: "Cari Anggota",
  site_recreate_confirm: "Apakah Anda yakin ingin membuat ulang situs \"{name}\"?",
  search_by_game_type: "Cari Berdasarkan Jenis Permainan",
  total_not_count_by_date_range: "Total ini tidak dihitung berdasarkan rentang tanggal",
  tooltips_upload_size: "Ukuran file yang diunggah tidak boleh melebihi 1mb.",
  tooltips_href: "Field Href memerlukan ekstensi domain. Misalnya: 'yourwebsite.com/promotions', cukup isi 'promotions'.",
  d_winlose_chart: "Visualisasikan tren menang/kalah dan penarikan.",
  d_turnover_chart: "Analisis tren omset dan setoran.",
  d_deposit: "Menampilkan jumlah setoran dan anggota unik.",
  d_withdrawal: "Menampilkan total transaksi penarikan.",
  d_active_player: "Total taruhan dan login unik oleh pemain.",
  d_winlose: "Menampilkan total kemenangan/kerugian bersih.",
  d_turnover: "Total omset yang dihasilkan.",
  d_member: "Jumlah semua anggota terdaftar.",
  d_referee: "Total jumlah rujukan pengguna.",
  d_verfied_signup: "Jumlah pengguna terverifikasi dan pendaftaran baru.",
  d_ftd: "Jumlah dan jumlah setoran pertama kali.",
  d_top_winner: "ID Pemain dan total jumlah kemenangan.",
  d_top_loser: "ID Pemain dan total jumlah kerugian.",
  d_top_deposit: "ID Pemain dan total jumlah setoran dari yang terbanyak hingga yang tersedikit.",
  d_top_withdrawal: "ID Pemain dan total jumlah penarikan dari yang terbanyak hingga yang tersedikit.",
  d_top_promotion: "Peringkat, ID promosi, nama, dan klaim oleh pemain.",
  d_payment_gateway: "Peringkat, metode, vendor, diproses, ditolak, total, dan tingkat keberhasilan melalui gateway.",
  tooltips_promo_member_custom: "Tolong masukkan beberapa ID anggota dengan pemisah koma. Eg: member001,member002,member003",
  tooltips_social_facebook: "Contoh: https://www.facebook.com/",
  tooltips_social_instagram: "Contoh: https://www.instagram.com/",
  tooltips_social_skype: "Contoh: skype:<username>?chat",
  tooltips_social_telegram: "Contoh: https://t.me/<ID>",
  tooltips_social_tiktok: "Contoh: https://www.tiktok.com/<ID>",
  tooltips_social_wechat: "Contoh: <ID>",
  tooltips_social_whatsapp: "Contoh: https://wa.me/<ID>",
  tooltips_social_youtube: "Contoh: https://www.youtube.com/<ID>",
  search_by_business_id: "Cari Berdasarkan ID Bisnis",
  ticket_taken_confirm: "Apakah Anda yakin ingin mengambil alih tiket ID ini \"{name}\"?",
  tooltips_payment_setting: "Yang di bawah ini hanya akan tercermin jika 'Pengaturan' - 'Pengaturan Pembayaran' diatur ke 'SENDIRI'",
  tooltips_cms_announcement_main: "MMaksimum 5 banner pengumuman untuk pengalaman pengguna terbaik",
  tooltips_cms_announcement_title: "Maksimal 30 karakter untuk pengalaman pengguna terbaik",
  tooltips_cms_announcement_body: "Maksimal 200 karakter untuk pengalaman pengguna terbaik",
  delete_livechat_confirm: "Apakah Anda yakin ingin menghapus obrolan langsung?",
  tooltips_vip_name: "Maksimum 10 karakter untuk pengalaman pengguna terbaik",

  choosePackage: "Pilih Paket",
  effortlessCreate: "Buat, optimalkan, dan kelola situs web Anda dengan mudah!",
  raiseNewHeight: "Membawa Anda ke level yang lebih tinggi",
  fastSecureStable: "Cepat, Aman, dan Stabil",
  realTimeData: "Wawasan Data Real-Time",
  highLevelTechTeam: "Tim Teknologi Tingkat Tinggi!",
  strategicEmpowerment: "Pemberdayaan Strategis!",
  supportFirst: "Dukungan 24/7 mengutamakan Anda dengan solusi yang dipersonalisasi!",
  empowermentBusiness: "Pemberdayaan melalui paket Eksekutif untuk mencapai tujuan bisnis!",
  pleaseFillUpSiteDetails: "Harap isi detail situs Anda",
  reviewYourOptionsAndCheckout: "Tinjau pilihan Anda dan lanjutkan ke pembayaran",
  chooseYourPreferedResponsiveLayoutTheme: "Pilih tema tata letak responsif yang Anda sukai",
  chooseYourPreferedColor: "Pilih warna yang Anda sukai",
  pleaseSelectTheme: "Silakan Pilih Tema",
  pleaseSelectColor: "Silakan Pilih Warna",
  websiteLayoutAndThemeDesign: "Tata Letak dan Desain Tema Situs Web",
  operatorAccCreatedSuccessful: "Akun Operator Berhasil Dibuat",
  delete_default_template_confirm: "Apakah Anda yakin ingin menghapus template permainan mini \"{template}\"?",
  search_by_template_code: "Cari berdasarkan Kode Template",
  delete_mini_game_confirm: "Apakah Anda yakin ingin menghapus permainan mini \"{minigame}\"?",
  delete_mini_game_template_confirm: "Apakah Anda yakin ingin menghapus template permainan mini \"{minigametemplate}\"?",
  delete_reward_confirm: "Apakah Anda yakin ingin menghapus hadiah \"{reward}\"?",
  search_by_game_name: "Cari berdasarkan Nama Permainan",
  tooltips_gamereward: "Batas: {max}",
  change_gamify_status_confirm: "Apakah Anda yakin ingin mengubah status hadiah \"{gamify}\"?",
  change_gamify_login_status_confirm: "Apakah Anda yakin ingin mengubah status login hadiah \"{gamify}\"?",
  change_gamify_daily_login_status_confirm: "Apakah Anda yakin ingin mengubah status hadiah Check-in Harian (Login Harian)?",
  change_partner_seq_confirm: "Apakah kamu yakin ingin mengubah urutan \"{id}\"?",
  tooltips_partners_link: "Contoh: https://www.google.com/",
  delete_partner_confirm: "Apakah Anda yakin ingin menghapus mitra \"{name}\"?",
  change_account_chat_status_confirm: "Apakah Anda yakin ingin mengubah status livechat?",
  uploadYourManifestWithPngJpegFormat: "Unggah manifest Anda dalam format png atau jpeg",
  imageDimensionMustBeAtLeast512: "Dimensi gambar harus minimal 512x512 piksel",
  whitelist_ip_tooltips: "Silakan beri tahu penyedia untuk memasukkan IP: \"{ip}\" ke daftar putih.",
  tooltips_inpay_api_url: "Contoh: https://www.google.com/",
};
